import styled from '@emotion/styled'
import { HeaderXXXXLarge600Style } from '../../../../styles/Text.styles'
import theme from '../../../../styles/theme'

export const SolutionPosterContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 1.5rem;
  flex-wrap: wrap;
`

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 1.3rem;
  justify-content: center;
  align-items: center;
`

export const SolutionPoster = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(50% - 112px);
  align-items: center;
  border-radius: 0.75rem;
  background: ${`${theme.colors.primary}50`};
  padding: 2rem 3rem;
`

export const SolutionPosterTitle = styled.h1`
  ${HeaderXXXXLarge600Style};
  font-family: Neuton;
  color: ${theme.colors.standardText};
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  margin: 0;
`
